module.exports = __webpack_public_path__ + "img/unchecked-favor-hover.ff61f78c.svg";